import React from "react";
import PageContainerAuth from "../../components/common/PageContainerAuth";
import TemplatesSection from "../../components/pages/templates/TemplatesSection";

export function Templates() {

    return (
        <PageContainerAuth section="mailings-templates" pageTitle="Templates email">
            <TemplatesSection />
        </PageContainerAuth>
    );
}